import type { Brand } from '@common/api/brandGroupService';

/**
 * Every Workspace has one shared Business group that cannot be deleted.
 * Prefer the API's explicit marker. During the API backfill, use the first
 * shared group so the default group keeps the same protection in Admin.
 */
export const getDefaultBusinessGroupId = (brands: readonly Brand[]): string | null =>
  brands.find((brand) => brand.isDefault === true || brand.default === true)?.id ??
  brands.find((brand) => brand.visibility !== 'PRIVATE')?.id ??
  null;

/**
 * Apply the default marker chosen from the navigation Project list to another
 * Project collection, such as the integration-assignment picker. The picker
 * can contain a different visibility-scoped subset, so it must not infer a
 * new default from its first public Project.
 */
export const applyDefaultBusinessGroupMarker = (
  brands: Brand[],
  defaultBusinessGroupId: string | null,
): Brand[] =>
  brands.map((brand) => ({
    ...brand,
    isDefault: brand.id === defaultBusinessGroupId,
  }));

export const normalizeDefaultBusinessGroup = (brands: Brand[]): Brand[] => {
  const defaultBusinessGroupId = getDefaultBusinessGroupId(brands);

  return applyDefaultBusinessGroupMarker(brands, defaultBusinessGroupId);
};
